import React from 'react';
import Toaster from "../components/toaster/Toaster"

export default class ToasterSingleton {
    static privateInstance = null;

    componente = null;
    elencoToaster = [];
    identificativoCorrente = 0;

    static instance() {

        if (this.privateInstance == null) {
            this.privateInstance = new ToasterSingleton();
        }

        return this.privateInstance;
    }

    pulisci() {

        this.elencoToaster = []
    }

    sottoscrizione(object) {
        this.componente = object;
    }

    cancellazioneSottoscrizione() {
        this.componente = null;
    }

    aggiuntaToaster(toaster) {

        console.log(toaster);

        if (toaster) {
            toaster.id = this.identificativoCorrente;
            this.identificativoCorrente++;
            this.elencoToaster.splice(0, 1, toaster);
        }
        this.componente.setState(this.componente.state);

    }

    onCloseToaster(toasterId) {

        var index = this.elencoToaster.indexOf(this.elencoToaster.find(toaster => {
            return toaster.id === toasterId
        }));

        if (index !== -1) {
            this.elencoToaster.splice(index, 1);
        }

        this.componente.setState(this.componente.state);

    }

    renderToaster() {

        return this.elencoToaster.map(toaster => {
            return (
                <div className={"row"} key={toaster.id} style={{paddingTop: "1rem"}}>
                    <Toaster identificativo={toaster.identificativo} id={toaster.id} type={toaster.type}
                             text={toaster.text} toaster={toaster} textList={toaster.textList} title={toaster.title}/>
                </div>
            )
        })
    }
}
